// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ApplyProcess — two full-width stacked zones
   Zone 1 (cream):  THE APPLICATION PROCESS header + step grid
   Zone 2 (surface): COMMON QUESTIONS in a 2-col FAQ grid
   ============================================================ */

.aprc {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--line);
}

/* ── ZONE 1 — Process steps ──────────────────────────────── */
.aprc__process-zone {
  background: var(--c-cream);
  padding-block: var(--section-y);
  border-bottom: 1px solid var(--line);
}

.aprc__process-header {
  margin-bottom: clamp(2rem, 4vw, 3.5rem);
}

.aprc__title {
  font-family: var(--font-body);
  font-size: var(--fs-h3);
  font-weight: 700;
  color: var(--c-ink);
  margin: 0 0 var(--sp-3);
}

.aprc__sub {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
  max-width: 52rem;
}

/* Step row — stretch evenly across the full container */
.aprc__steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0;
  width: 100%;
}

.aprc__step-group {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}

/* Last group shouldn't grow beyond its card */
.aprc__step-group:last-child {
  flex: 0 0 auto;
}

/* Individual step card */
.aprc__step {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(0.85rem, 1.5vw, 1.25rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-3);
  flex-shrink: 0;
  width: clamp(110px, 15vw, 165px);
  background: var(--c-cream);
  transition:
    box-shadow var(--dur) var(--ease),
    transform var(--dur) var(--ease);
}

.aprc__step:hover {
  box-shadow: 0 6px 20px rgba(27, 27, 27, 0.08);
  transform: translateY(-2px);
}

/* Active (Submit) card — rust fill */
.aprc__step--active {
  background: var(--accent);
  border-color: var(--accent);
}
.aprc__step--active .aprc__step-icon,
.aprc__step--active .aprc__step-num,
.aprc__step--active .aprc__step-label,
.aprc__step--active .aprc__step-desc {
  color: rgba(255, 255, 255, 0.92) !important;
}

.aprc__step-icon {
  font-size: clamp(1.5rem, 2.5vw, 2rem);
  color: var(--c-forest);

  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--sp-1);
}

.aprc__step-num {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 500;
  color: var(--text-muted);
  letter-spacing: 0.06em;
  /* Inline with label on desktop via .aprc__step-num-label flex row */
}

.aprc__step-num-label {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.4rem;
}

.aprc__step-label {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--c-ink);
  margin: 0;
  text-transform: uppercase;
}

.aprc__step-desc {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin: 0;
  line-height: 1.5;
}

.aprc__step-content {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  align-items: center;
}

/* aprc__step-arrow shown only on mobile via media query */

/* Arrow connector between steps */
.aprc__arrow {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: rgba(27, 27, 27, 0.22);

  min-width: 0.5rem;
  max-width: 2.5rem;
}

/* ── ZONE 2 — FAQ ───────────────────────────────────────── */
.aprc__faq-zone {
  background: var(--surface);
  padding-block: var(--section-y);
}

/* Centred eyebrow with flanking rules */
.aprc__faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(1rem, 3vw, 2.5rem);
  margin-bottom: clamp(2rem, 4vw, 3.5rem);
}

.aprc__faq-rule {
  flex: 1 1;
  max-width: clamp(4rem, 10vw, 8rem);
  height: 1px;
  background: var(--line);
  display: block;
}

.aprc__faq-heading {
  /* u-eyebrow handles font/size/tracking */
  color: var(--accent) !important;
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}

/* Two-column grid of FAQ items */
.aprc__faq-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 clamp(3rem, 6vw, 6rem);
}

/* Individual FAQ item */
.apfaq__item {
  border-bottom: 1px solid var(--line);
}

.apfaq__q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  background: none;
  border: none;
  padding: var(--sp-5) 0;
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 500;
  color: var(--c-ink);
  text-align: left;
  cursor: pointer;
  transition: color var(--dur) var(--ease);
}
.apfaq__q:hover {
  color: var(--accent);
}

.apfaq__chevron {
  font-size: 0.7rem;
  color: var(--accent);
  flex-shrink: 0;
  transition: transform 0.3s var(--ease);
}

.apfaq__a {
  overflow: hidden;
}
.apfaq__a p {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  padding-bottom: var(--sp-5);
  margin: 0;
}

/* ══════════════════════════════════════════════════════════════
   MOBILE — process steps as horizontal list rows (not small cards)
   Matches the design: icon left | num+label+desc centre | arrow right
══════════════════════════════════════════════════════════════ */
@media (max-width: 767.98px) {
  .aprc__process-zone {
    padding-block: var(--sp-8) var(--sp-7);
  }

  /* Stack steps vertically */
  .aprc__steps {
    flex-direction: column;
    gap: 0;
    overflow: visible;
    justify-content: flex-start;
  }

  .aprc__step-group {
    flex-direction: column;
    align-items: stretch;
    flex: none;
    width: 100%;
  }

  /* Each step = full-width horizontal row */
  .aprc__step {
    flex-direction: row;
    align-items: center;
    text-align: left;
    width: 100%;
    padding: var(--sp-5);
    gap: var(--sp-4);
    border: 1px solid var(--line);
    border-radius: var(--radius-sm);
    margin-bottom: var(--sp-3);
  }
  .aprc__step:hover {
    box-shadow: 0 4px 16px rgba(27, 27, 27, 0.07);
  }

  .aprc__step-icon {
    font-size: 1.5rem;
    color: var(--c-forest);
    flex-shrink: 0;
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Centre: num label desc stacked */
  .aprc__step-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }

  .aprc__step-num {
    font-size: var(--fs-sm);
    font-weight: 500;
    color: var(--text-muted);
    display: inline;
  }

  .aprc__step-label {
    font-size: var(--fs-sm);
    font-weight: 700;
    letter-spacing: 0.1em;
    color: var(--c-ink);
    display: inline;
    margin-left: 0.35rem;
  }

  .aprc__step-num-label {
    display: flex;
    align-items: baseline;
    gap: 0.35rem;
  }

  .aprc__step-desc {
    font-size: var(--fs-sm);
    color: var(--text-muted);
    line-height: var(--lh-snug);
  }

  /* Arrow on the right */
  .aprc__step-arrow {
    font-size: 0.75rem;
    color: var(--accent);
    flex-shrink: 0;
  }

  /* Active (Submit) row */
  .aprc__step--active {
    background: var(--accent);
    border-color: var(--accent);
  }
  .aprc__step--active .aprc__step-icon,
  .aprc__step--active .aprc__step-num,
  .aprc__step--active .aprc__step-label,
  .aprc__step--active .aprc__step-desc,
  .aprc__step--active .aprc__step-arrow {
    color: rgba(255, 255, 255, 0.92) !important;
  }

  /* Hide horizontal desktop arrow connectors */
  .aprc__arrow {
    display: none;
  }

  /* FAQ single column */
  .aprc__faq-grid {
    grid-template-columns: 1fr;
  }
  .apfaq__q {
    font-size: var(--fs-body);
  }
  .apfaq__a p {
    font-size: var(--fs-body);
  }

  /* Titles larger on mobile */
  .aprc__title {
    font-size: var(--fs-h2);
  }
  .aprc__sub {
    font-size: var(--fs-body);
  }
  .aprc__faq-heading {
    font-size: var(--fs-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyProcess.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,+DAA+D;AAC/D;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,oEAAoE;EACpE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;EAC1B;;oCAEkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;;;EAIE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;;EAEtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0DAA0D;;AAE1D,kCAAkC;AAClC;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;;EAE7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;;gEAGgE;AAChE;EACE;IACE,sCAAsC;EACxC;;EAEA,2BAA2B;EAC3B;IACE,sBAAsB;IACtB,MAAM;IACN,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,WAAW;EACb;;EAEA,0CAA0C;EAC1C;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;EAC5B;EACA;IACE,6CAA6C;EAC/C;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;EAChB;;EAEA,wBAAwB;EACxB;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;;;;;IAKE,2CAA2C;EAC7C;;EAEA,6CAA6C;EAC7C;IACE,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA,4BAA4B;EAC5B;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ============================================================\n   ApplyProcess — two full-width stacked zones\n   Zone 1 (cream):  THE APPLICATION PROCESS header + step grid\n   Zone 2 (surface): COMMON QUESTIONS in a 2-col FAQ grid\n   ============================================================ */\n\n.aprc {\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid var(--line);\n}\n\n/* ── ZONE 1 — Process steps ──────────────────────────────── */\n.aprc__process-zone {\n  background: var(--c-cream);\n  padding-block: var(--section-y);\n  border-bottom: 1px solid var(--line);\n}\n\n.aprc__process-header {\n  margin-bottom: clamp(2rem, 4vw, 3.5rem);\n}\n\n.aprc__title {\n  font-family: var(--font-body);\n  font-size: var(--fs-h3);\n  font-weight: 700;\n  color: var(--c-ink);\n  margin: 0 0 var(--sp-3);\n}\n\n.aprc__sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n  max-width: 52rem;\n}\n\n/* Step row — stretch evenly across the full container */\n.aprc__steps {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0;\n  width: 100%;\n}\n\n.aprc__step-group {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Last group shouldn't grow beyond its card */\n.aprc__step-group:last-child {\n  flex: 0 0 auto;\n}\n\n/* Individual step card */\n.aprc__step {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(0.85rem, 1.5vw, 1.25rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--sp-3);\n  flex-shrink: 0;\n  width: clamp(110px, 15vw, 165px);\n  background: var(--c-cream);\n  transition:\n    box-shadow var(--dur) var(--ease),\n    transform var(--dur) var(--ease);\n}\n\n.aprc__step:hover {\n  box-shadow: 0 6px 20px rgba(27, 27, 27, 0.08);\n  transform: translateY(-2px);\n}\n\n/* Active (Submit) card — rust fill */\n.aprc__step--active {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.aprc__step--active .aprc__step-icon,\n.aprc__step--active .aprc__step-num,\n.aprc__step--active .aprc__step-label,\n.aprc__step--active .aprc__step-desc {\n  color: rgba(255, 255, 255, 0.92) !important;\n}\n\n.aprc__step-icon {\n  font-size: clamp(1.5rem, 2.5vw, 2rem);\n  color: var(--c-forest);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--sp-1);\n}\n\n.aprc__step-num {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 500;\n  color: var(--text-muted);\n  letter-spacing: 0.06em;\n  /* Inline with label on desktop via .aprc__step-num-label flex row */\n}\n\n.aprc__step-num-label {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 0.4rem;\n}\n\n.aprc__step-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: var(--c-ink);\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.aprc__step-desc {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.aprc__step-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n  align-items: center;\n}\n\n/* aprc__step-arrow shown only on mobile via media query */\n\n/* Arrow connector between steps */\n.aprc__arrow {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  color: rgba(27, 27, 27, 0.22);\n\n  min-width: 0.5rem;\n  max-width: 2.5rem;\n}\n\n/* ── ZONE 2 — FAQ ───────────────────────────────────────── */\n.aprc__faq-zone {\n  background: var(--surface);\n  padding-block: var(--section-y);\n}\n\n/* Centred eyebrow with flanking rules */\n.aprc__faq-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(1rem, 3vw, 2.5rem);\n  margin-bottom: clamp(2rem, 4vw, 3.5rem);\n}\n\n.aprc__faq-rule {\n  flex: 1;\n  max-width: clamp(4rem, 10vw, 8rem);\n  height: 1px;\n  background: var(--line);\n  display: block;\n}\n\n.aprc__faq-heading {\n  /* u-eyebrow handles font/size/tracking */\n  color: var(--accent) !important;\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n/* Two-column grid of FAQ items */\n.aprc__faq-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 clamp(3rem, 6vw, 6rem);\n}\n\n/* Individual FAQ item */\n.apfaq__item {\n  border-bottom: 1px solid var(--line);\n}\n\n.apfaq__q {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-4);\n  background: none;\n  border: none;\n  padding: var(--sp-5) 0;\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 500;\n  color: var(--c-ink);\n  text-align: left;\n  cursor: pointer;\n  transition: color var(--dur) var(--ease);\n}\n.apfaq__q:hover {\n  color: var(--accent);\n}\n\n.apfaq__chevron {\n  font-size: 0.7rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  transition: transform 0.3s var(--ease);\n}\n\n.apfaq__a {\n  overflow: hidden;\n}\n.apfaq__a p {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  padding-bottom: var(--sp-5);\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   MOBILE — process steps as horizontal list rows (not small cards)\n   Matches the design: icon left | num+label+desc centre | arrow right\n══════════════════════════════════════════════════════════════ */\n@media (max-width: 767.98px) {\n  .aprc__process-zone {\n    padding-block: var(--sp-8) var(--sp-7);\n  }\n\n  /* Stack steps vertically */\n  .aprc__steps {\n    flex-direction: column;\n    gap: 0;\n    overflow: visible;\n    justify-content: flex-start;\n  }\n\n  .aprc__step-group {\n    flex-direction: column;\n    align-items: stretch;\n    flex: none;\n    width: 100%;\n  }\n\n  /* Each step = full-width horizontal row */\n  .aprc__step {\n    flex-direction: row;\n    align-items: center;\n    text-align: left;\n    width: 100%;\n    padding: var(--sp-5);\n    gap: var(--sp-4);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-sm);\n    margin-bottom: var(--sp-3);\n  }\n  .aprc__step:hover {\n    box-shadow: 0 4px 16px rgba(27, 27, 27, 0.07);\n  }\n\n  .aprc__step-icon {\n    font-size: 1.5rem;\n    color: var(--c-forest);\n    flex-shrink: 0;\n    width: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Centre: num label desc stacked */\n  .aprc__step-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n  }\n\n  .aprc__step-num {\n    font-size: var(--fs-sm);\n    font-weight: 500;\n    color: var(--text-muted);\n    display: inline;\n  }\n\n  .aprc__step-label {\n    font-size: var(--fs-sm);\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    color: var(--c-ink);\n    display: inline;\n    margin-left: 0.35rem;\n  }\n\n  .aprc__step-num-label {\n    display: flex;\n    align-items: baseline;\n    gap: 0.35rem;\n  }\n\n  .aprc__step-desc {\n    font-size: var(--fs-sm);\n    color: var(--text-muted);\n    line-height: var(--lh-snug);\n  }\n\n  /* Arrow on the right */\n  .aprc__step-arrow {\n    font-size: 0.75rem;\n    color: var(--accent);\n    flex-shrink: 0;\n  }\n\n  /* Active (Submit) row */\n  .aprc__step--active {\n    background: var(--accent);\n    border-color: var(--accent);\n  }\n  .aprc__step--active .aprc__step-icon,\n  .aprc__step--active .aprc__step-num,\n  .aprc__step--active .aprc__step-label,\n  .aprc__step--active .aprc__step-desc,\n  .aprc__step--active .aprc__step-arrow {\n    color: rgba(255, 255, 255, 0.92) !important;\n  }\n\n  /* Hide horizontal desktop arrow connectors */\n  .aprc__arrow {\n    display: none;\n  }\n\n  /* FAQ single column */\n  .aprc__faq-grid {\n    grid-template-columns: 1fr;\n  }\n  .apfaq__q {\n    font-size: var(--fs-body);\n  }\n  .apfaq__a p {\n    font-size: var(--fs-body);\n  }\n\n  /* Titles larger on mobile */\n  .aprc__title {\n    font-size: var(--fs-h2);\n  }\n  .aprc__sub {\n    font-size: var(--fs-body);\n  }\n  .aprc__faq-heading {\n    font-size: var(--fs-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
